import React from 'react';
import styles from './RadioButtonGroup.module.css';

const RadioButtonGroup = ({ value, onChange, options, className }) => {
  const handleChange = (selectedValue) => {
    onChange(selectedValue);
  };

  return (
    <div className={`${styles.radioButtonGroup} ${className || ''}`}>
      {options.map((option) => (
        <label 
          key={option.value} 
          className={`${styles.radioButtonLabel} ${value === option.value ? styles.selected : ''}`}
        >
          <input
            type="radio"
            name="radio-group"
            value={option.value}
            checked={value === option.value}
            onChange={() => handleChange(option.value)}
            className={styles.radioButton}
          />
          <span className={styles.radioButtonText}>
            {option.label}
          </span>
        </label>
      ))}
    </div>
  );
};

export default RadioButtonGroup;
